module.exports = "https://static.wmbcdn.com/uniweb/images/726381d49d53221029f7876f5c702ad2.svg";